import { Component } from 'react';
import PropTypes from 'prop-types';

class Card extends Component {
  getImage() {
    const { itemImage, placeholderImage } = this.props;

    const middleImage = itemImage.middle_image;

    return middleImage || placeholderImage;
  }

  render() {
    const { title, slogan, summary, baseLink, slug } = this.props;

    const image = this.getImage();
    const link = `${baseLink}/${slug}`;

    return (
      <div className="card card-services">
        <div className="card__header">
          <a href={link}>
            <div className="card__image">
              <img
                width="348"
                height="256"
                className="card__image-value"
                src={image}
                alt={title}
                loading="lazy"
              />
            </div>
          </a>
        </div>
        <div
          className="card__content service-content"
          data-match-height="service-content"
        >
          <h1 className="card__title" data-match-height="service-title">
            {title}
          </h1>
          <h2 className="card__phrase">{slogan}</h2>
          <p className="card__summary">{summary}</p>
        </div>
        <div className="card__footer">
          <a
            href={link}
            className="btn button button--block button--large button--primary card__cta"
          >
            Agendar serviço
          </a>
        </div>
      </div>
    );
  }
}

Card.defaultProps = {
  itemImage: {},
  title: '',
  slogan: '',
  summary: '',
  baseLink: '',
  slug: '',
  placeholderImage: '',
};

Card.propTypes = {
  itemImage: PropTypes.shape({
    main_image: PropTypes.string,
    middle_image: PropTypes.string,
    thumb_image: PropTypes.string,
    url: PropTypes.string,
  }),
  title: PropTypes.string,
  slogan: PropTypes.string,
  summary: PropTypes.string,
  baseLink: PropTypes.string,
  slug: PropTypes.string,
  placeholderImage: PropTypes.string,
};

export default Card;
